import React from "react";
import { motion } from "framer-motion";


const Sectwo = () => {

    const glideLeft = {
        initial: { opacity: 0, x: 60 },
        whileInView: { opacity: 1, x: 0 },
        transition: { duration: 0.7 },
        viewport: { once: true }
    };

    return(
        <>
          <div className="container" style={{marginTop: '70px'}}>
              <div className="mb-5">
                    <h2 style={{ fontWeight: "700" }}>
                    <span style={{ color: "#353995" }}>OUR</span>{" "}
                    <span style={{ color: "#F29235" }}>PROCESS</span>
                    </h2>
                    <p>A battle-tested methodology for delivering high quality digital products.</p>
                </div>
                <div className="row">

                <div className="col-12 col-sm-6 p-3 col-lg-2">
                    <motion.div {...glideLeft}>
                    <h1 className="circle">1</h1>
                    <h5 className="mt-4 fw-bold" style={{ color: "#353995" }}>DISCOVERY</h5>
                    <p>Defining goals, project scope, and business requirements.</p>
                    </motion.div>
                </div>

                <div className="col-12 col-sm-6 p-3 col-lg-2">
                    <motion.div {...glideLeft}>
                    <h1 className="circle">2</h1>
                    <h5 className="mt-4 fw-bold" style={{ color: "#353995" }}>ARCHITECTURE</h5>
                    <p>Building wireframes and planning the technical stack.</p>
                    </motion.div>
                </div>

                <div className="col-12 col-sm-6 p-3 col-lg-2">
                    <motion.div {...glideLeft}>
                    <h1 className="circle">3</h1>
                    <h5 className="mt-4 fw-bold" style={{ color: "#353995" }}>DESIGN</h5>
                    <p>Crafting beautiful, brand-aligned user interfaces.</p>
                    </motion.div>
                </div>

                <div className="col-12 col-sm-6 p-3 col-lg-2">
                    <motion.div {...glideLeft}>
                    <h1 className="circle">4</h1>
                    <h5 className="mt-4 fw-bold" style={{ color: "#353995" }}>DEV</h5>
                    <p>Clean, efficient coding and integration phase.</p>
                    </motion.div>
                </div>

                <div className="col-12 mt-3 col-sm-6 col-lg-2">
                    <motion.div {...glideLeft}>
                    <h1 className="circle" style={{background:'#F29235'}}>5</h1>
                    <h5 className="mt-4 fw-bold" style={{ color: "#353995" }}>LAUNCH</h5>
                    <p>QA testing, deployment, and ongoing support.</p>
                    </motion.div>
                </div>

        </div>
          </div>
        </>
    )
}

export default Sectwo;